<div class="content-wrapper">
    <div class="content-body">
        <section id="package">
            <ng-template #content>
                <div id="modal">
                    <div class="modal-header font-weight-bold">
                        <h4 class="modal-title font-weight-bold">Official Announcement</h4>
                        <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                (click)="modalService.dismissAll('')"
                        >
                            ×
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <img [src]="imageBaseUrl+announcementDetail['announcement_doc'].partial_url"
                                     alt="Official Announcement" width="450px" height="600px"/>
                            </div>
                        </div>
                    </div>
                    <!--<div class="modal-footer">
                        <button class="btn btn-success color-white pull-right" [disabled]="submitting"
                        >
                            <i class="fas fa-pen-square mr-1" *ngIf="!submitting"></i>
                            <i class="fas fa-spinner fa-pulse mr-1" *ngIf="submitting"></i>View
                        </button>
                    </div>-->
                </div>
            </ng-template>
            <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12">
                    <h2 class="mt-5px">Official Announcement</h2>
                </div>
                <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-12">
                    <button class="btn btn-primary pull-right color-white color-white users-btn mr-2"
                            (click)="showSearch = !showSearch">
                        <i aria-hidden="true" class="fa fa-search mr-8px"></i>&nbsp;Search
                    </button>
                </div>
            </div>
            <div class="row search-card mt-3" *ngIf="showSearch">
                <div class="col-12">
                    <form class="form mt-2 mb--8px" novalidate [formGroup]="searchForm">
                        <div class="row">
                            <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="text" formControlName="title" placeholder="Title">
                                </fieldset>
                            </div>

                            <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12 text-center">
                                <button class="btn btn-primary btn-block btn-raised color-white mr-2 users-btn"
                                        (click)="search()"
                                        [disabled]="submitting">
                                    <i class="fas fa-spinner fa-pulse mr-1" *ngIf="submitting"></i>Search
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row mt-3" *ngIf="announcement && announcement.length > 0; else noDataToShow">
                <div class="col-12">
                    <div class="card" *ngFor="let announce of announcement; let i = index">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="f_20 font-weight-bold">{{(pagination.page - 1) * (pagination.perpage ? pagination.perpage : 0) + i + 1}}.</span>
                                </div>
                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="font-weight-bold text-italic f_15 text-blue cursor-pointer">{{announce?.created_at}}</span>
                                    <br>
                                    <small class="text-italic">Date</small>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 text-center mt-auto mb-auto">

                                    <span class="font-weight-bold text-italic f_15 ">{{announce?.title}}</span>
                                    <br>
                                    <small class="text-italic">Title</small>
                                </div>
                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                    <button class="font-weight-bold text-italic f_15 cursor-pointer btn btn-primary" (click)="openStatusModal(content,announce)">
                                        <!--<i class="fa fa-list-alt f_20 text-success mr-5px" title="Change Status"></i> -->View More
                                    </button>
                                    <br>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #noDataToShow>
                <div class="row mt-3">
                    <div class="col-12">
                        <div class="card p-50px">
                            <div class="card-body text-center">
                                <div class="row">
                                    <div class="col-12">
                                        <i class="fa fa-list-alt fa-3x" aria-hidden="true"></i>
                                    </div>
                                    <div class="col-12 text-center">
                                        No Announcement to show
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <div class="row pagination-table">
                <ngb-pagination class="pagination-primary" [collectionSize]="pagination.total"
                                [(page)]="pagination.page" [boundaryLinks]="true"
                                [pageSize]="pagination.perpage" [maxSize]="5"
                                (pageChange)="onPageChange($event)">
                    <ng-template ngbPaginationPrevious>
                        <span [data-feather]="'chevron-left'" [size]="18"
                              [class]="'font-weight-bolder'">
                        </span>
                    </ng-template>
                    <ng-template ngbPaginationNext>
                        <span [data-feather]="'chevron-right'" [size]="18"
                              [class]="'font-weight-bolder'">
                        </span>
                    </ng-template>
                </ngb-pagination>
            </div>
        </section>
    </div>
</div>
